export default class local{
    constructor() {
    }

    set = (key,data)=>{
        return localStorage.setItem(key, data);
    };
    get = (key)=>{
        return localStorage.getItem(key);
    };
    remove=(key) =>{
        return localStorage.removeItem(key);
    };

    clearAll=() =>{
        return localStorage.clear();
    };
}


// WEBPACK FOOTER //
// ./src/controller/continue/local.js